import { useEffect, useMemo, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase-client';
import {
  extractRuleCompatibleSupportAdminIds,
  extractSupportAdminIds,
} from '../utils/supportAdmins';

export {
  extractRuleCompatibleSupportAdminIds,
  extractSupportAdminIds,
};

export function useSupportAdminAccess(uid = '') {
  const [supportAdminIds, setSupportAdminIds] = useState([]);
  const [ruleCompatibleSupportAdminIds, setRuleCompatibleSupportAdminIds] = useState([]);
  const [loading, setLoading] = useState(Boolean(uid));

  useEffect(() => {
    if (!uid) {
      setSupportAdminIds([]);
      setRuleCompatibleSupportAdminIds([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    const loadSupportAdmins = async () => {
      setLoading(true);
      try {
        const snap = await getDoc(doc(db, 'appSettings', 'support'));
        if (cancelled) return;
        const data = snap.exists() ? snap.data() : {};
        setSupportAdminIds(snap.exists() ? extractSupportAdminIds(data) : []);
        setRuleCompatibleSupportAdminIds(snap.exists() ? extractRuleCompatibleSupportAdminIds(data) : []);
      } catch (err) {
        if (!cancelled) {
          setSupportAdminIds([]);
          setRuleCompatibleSupportAdminIds([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadSupportAdmins();
    return () => {
      cancelled = true;
    };
  }, [uid]);

  const isSupportAdmin = useMemo(
    () => Boolean(uid && ruleCompatibleSupportAdminIds.includes(uid)),
    [ruleCompatibleSupportAdminIds, uid]
  );

  return {
    supportAdminIds,
    ruleCompatibleSupportAdminIds,
    isSupportAdmin,
    loading,
  };
}
